<template>
  <transition name="additional-nav-slide-down">
    <div
      v-show="shouldShowAccountNav"
      class="additional-nav__block account-nav"
      :class="{ 'account-nav--logged-in': loggedIn }"
      @mouseenter="$store.dispatch('nav/setAdditionalNav', 'account')"
      @mouseleave="$store.dispatch('nav/setAdditionalNav', '')"
    >
      <h3 class="account-nav__title">{{ $t('account.title') }}</h3>

      <LoginForm
        v-if="!loggedIn"
        ref="loginForm"
        actionType="login"
        :paths="paths"
        variant="navigation"
      />
      <div v-else class="account-nav__options">
        <div v-if="/\S/.test(firstName)" class="account-nav__option">{{ greeting }}</div>
        <a class="account-nav__option account-nav__option--link" :href="paths.profile">{{
          $t('account.profile.title')
        }}</a>
        <a class="account-nav__option account-nav__option--link" :href="paths.orders">{{
          $t('account.orders.title')
        }}</a>
        <a
          v-if="hasStoreCredits"
          class="account-nav__option account-nav__option--link"
          :href="paths.storeCredits"
          >{{ $t('account.store_credit.title') }}</a
        >
      </div>

      <div class="account-nav__footer">
        <a
          class="u-arrow-link u-arrow-link--light account-nav__footer-link"
          :href="footerLinkHref"
          :data-no-turbolink="loggedIn ? true : false"
          v-on="loggedIn ? { click: logOut } : {}"
          >{{ footerLinkText }}</a
        >
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/assets/javascripts/on/external-services/external-services'
import { registerStores } from '@/helpers/stores'
import accountStore from '@/stores/account'
import LoginForm from '@/components/_shared/LoginForm/LoginForm.vue'

export default {
  name: 'AccountNav',
  components: {
    LoginForm,
  },

  data() {
    return {
      isLoggingOut: false,
    }
  },

  computed: {
    ...mapGetters({
      firstName: 'account/firstName',
      loggedIn: 'account/loggedIn',
      paths: 'account/paths',
      hasStoreCredits: 'account/hasStoreCredits',
    }),

    shouldShowAccountNav() {
      return (
        this.$store.state.nav.currentAdditionalNav == 'account' ||
        this.$store.state.nav.accountNavMustStayOpen ||
        (this.$refs.loginForm && this.$refs.loginForm.isSubmitting) ||
        this.isLoggingOut
      )
    },

    greeting() {
      return this.$t('navigation.account.greeting').replace(/%\{name\}/, ` ${this.firstName}`)
    },

    footerLinkHref() {
      return this.loggedIn ? this.paths.logout : this.paths.signUp
    },

    footerLinkText() {
      return this.isLoggingOut
        ? this.$t('forms.processing')
        : this.$t(`checkout.login.${this.loggedIn ? 'logout' : 'sign_up'}`)
    },
  },

  beforeCreate() {
    registerStores({ account: accountStore })
  },

  mounted() {
    this.$store.dispatch('account/fetchData')
  },

  methods: {
    logOut() {
      this.isLoggingOut = true
      notifyExternalServices({
        action: ACTIONS.userAccount,
        details: { action: 'logout' },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.account-nav {
  z-index: 3;
  width: 320px;
  padding: #{$site-gutter-large - 5} $site-gutter-large #{$site-gutter-large - 15};

  &--logged-in {
    .account-nav__title {
      margin-bottom: $site-gutter-large - $site-gutter;
    }
  }

  &__title {
    margin-top: 0;
    margin-bottom: $site-gutter-large - 5;
    cursor: default;
  }

  &__options {
    margin-bottom: 15px;
  }

  &__option {
    position: relative;
    display: block;
    padding: $site-gutter #{$site-gutter - 5} #{$site-gutter - 1};
    border-bottom: 1px solid $color-navigation-border;
    color: $color-text-lighter;
    cursor: default;

    &--link {
      color: $color-text;
      cursor: pointer;

      &:after {
        @include icomoon-base-props;
        content: '\e601';
        position: absolute;
        top: 50%;
        right: $site-gutter - 5;
        font-size: $font-size-smaller;
        color: $color-link;
        transform: translateY(-50%);
      }

      &:hover:after {
        color: $color-link-hover;
      }
    }
  }

  &__footer {
    text-align: center;
  }

  &__footer-link {
    display: inline-block;
    padding: 10px;
  }
}
</style>
